import { ProductKeys } from '@config/keys/product.keys';
import { AdditionGroupKeys } from '@config/keys/shop.keys';
import { DoodProductModel } from '@core/models/product.model';
import { IAdditionGroup } from '@core/models/shop.model';

export class ProductPanelAdditionGroupUtil {
  static getSelectedQuantity(additionGroup: IAdditionGroup): number {
    return additionGroup[AdditionGroupKeys.Items].reduce((total, item: DoodProductModel) => {
      return total + ((item[ProductKeys.IsChecked] && (item[ProductKeys.Quantity] || 1)) || 0);
    }, 0);
  }

  static isMinCountReached(additionGroup: IAdditionGroup): boolean {
    const minCount = additionGroup[AdditionGroupKeys.MinCount] ?? additionGroup.min_count ?? 0;
    if (minCount <= 0) {
      return true;
    }
    return ProductPanelAdditionGroupUtil.getSelectedQuantity(additionGroup) >= minCount;
  }
}
